import type { PlacementBackendRuntimeConfig } from '../../../types';

/**
 * Merges a tunnel config overlay on top of base placementconfig.
 * Only the parts present in the overlay are replaced.
 */
export function mergePlacementConfigs(
	base: PlacementBackendRuntimeConfig,
	overlay: Partial<PlacementBackendRuntimeConfig>,
): PlacementBackendRuntimeConfig {
	// If overlay is empty, return base unchanged
	if (!overlay.placementStages && !overlay.messagesStages) {
		return base;
	}

	const merged: PlacementBackendRuntimeConfig = {
		...base,
		// Shallow copy to allow selective overrides
		placementStages: base.placementStages,
		messagesStages: { ...base.messagesStages },
	};

	// Override placement stages if present in overlay
	if (overlay.placementStages) {
		merged.placementStages = overlay.placementStages;
	}

	// Merge message template stages (per-template selective override)
	if (overlay.messagesStages) {
		Object.entries(overlay.messagesStages).forEach(([messageTemplateId, stages]) => {
			merged.messagesStages[messageTemplateId] = stages;
		});
	}

	return merged;
}
